module.exports = __webpack_public_path__ + "static/media/confirmed-status.0ee9fa1d.svg";